// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__0OqNW","spinner":"Loading_spinner__lo8+V","spin":"Loading_spin__NSZ1c"};